import $ from 'jquery';
import rivets from 'rivets';
import BaseView from '../../core/baseView';
import * as eventEmitter from '../../core/eventEmmiter';
import { reload } from '../../validation/validation-controller';
import BusinessSpecificBaseView from '../../layout/b2b/businessSpecificBaseView';
import RegisterFormPrivateCustomerView from '../../pages/login/registerFormPrivateCustomerView';

export default BusinessSpecificBaseView.extend(RegisterFormPrivateCustomerView).extend({

    events: $.extend({}, RegisterFormPrivateCustomerView.prototype.events, {
        'blur [name="telephone"]': 'onTelephoneFieldChange'
    }),

    selectors: {
        legalForm: '.js-company-legal-form select',
        registrationNumberWrapper: '.js-registration-number',
        companyHolderWrapper: '.js-registration-company-holder',
        combinedVatFieldsInput: '.js-combined-vat-fields',
        vatNumberField: '.js-company-vat-number input',
        hiddenClass: 'is-hidden'
    },

    initialize: function () {
        reload();
        this.$registrationNumber = this.$el.find(this.selectors.registrationNumberWrapper).find('input');
        this.$companyHolder = this.$el.find(this.selectors.companyHolderWrapper).find('input');
        this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);

        var businessSpecificModel = this.model.get('businessForm');

        this.$registrationNumber = this.$el.find(this.selectors.registrationNumberWrapper).find('input');
        this.$companyHolder = this.$el.find(this.selectors.companyHolderWrapper).find('input');
        this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);

        this.initializeModel(businessSpecificModel);
        this.addRulesToValidator();
        this.bindEvents(businessSpecificModel);
        this.triggerChanges(businessSpecificModel);
        this.setupRivetsBindings();
    },

    onBlur: RegisterFormPrivateCustomerView.prototype.onBlur,
    onRegisterPrivateCustomerSubmit: RegisterFormPrivateCustomerView.prototype.onRegisterPrivateCustomerSubmit,
    removeCompanyFromPrivateCustomer: RegisterFormPrivateCustomerView.prototype.removeCompanyFromPrivateCustomer,

    setupRivetsBindings: function () {
        rivets.bind(this.$el, {
            viewModel: this.model
        });
    },

    onTelephoneFieldChange: function () {
        eventEmitter.trigger('change:telephoneField');
    },

    destroy: function () {
        eventEmitter.off('validationReload', this.addRulesToValidator, this);
        BaseView.prototype.destroy.call(this);
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/registerFormBusinessCustomerView.js
 **/